import { RESET_STATE } from 'store/global/actions';
import { LOAN_APPLICATION_BORROWER_CRM_CONTACTS_ACTION_TYPE } from 'store/loanApplications/actions';

const initialState = {};

const loanApplicationBorrowerCrmContactsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_APPLICATION_BORROWER_CRM_CONTACTS_ACTION_TYPE.SET_BORROWER_CRM_CONTACTS: {
      return payload || initialState;
    }

    case LOAN_APPLICATION_BORROWER_CRM_CONTACTS_ACTION_TYPE.SET_BORROWER_CRM_CONTACT: {
      return { ...state, [payload.borrowerId]: payload.summary };
    }

    case LOAN_APPLICATION_BORROWER_CRM_CONTACTS_ACTION_TYPE.RESET_BORROWER_CRM_CONTACTS:
    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanApplicationBorrowerCrmContactsReducer;
